/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_How_NeckInputs */

const en_us2_body_measures_how_neck = /** @type {(inputs: Body_Measures_How_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just below the Adam's apple, the tape tilted slightly forward. Head level, looking ahead, shoulders loose.`)
};

const pt_br2_body_measures_how_neck = /** @type {(inputs: Body_Measures_How_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo abaixo do pomo de Adão, com a fita levemente inclinada para a frente. Cabeça reta, olhando para a frente, ombros soltos.`)
};

const es_419_body_measures_how_neck = /** @type {(inputs: Body_Measures_How_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Justo debajo de la nuez de Adán, con la cinta un poco inclinada hacia adelante. Cabeza derecha, mirando al frente, hombros sueltos.`)
};

const pt_pt2_body_measures_how_neck = /** @type {(inputs: Body_Measures_How_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logo abaixo da maçã de Adão, com a fita ligeiramente inclinada para a frente. Cabeça direita, a olhar em frente, ombros soltos.`)
};

const fr_fr2_body_measures_how_neck = /** @type {(inputs: Body_Measures_How_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juste sous la pomme d'Adam, le ruban légèrement incliné vers l'avant. Tête droite, regard devant, épaules relâchées.`)
};

const de_de2_body_measures_how_neck = /** @type {(inputs: Body_Measures_How_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direkt unter dem Adamsapfel, das Maßband leicht nach vorn geneigt. Kopf gerade, Blick nach vorn, Schultern locker.`)
};

const it_it2_body_measures_how_neck = /** @type {(inputs: Body_Measures_How_NeckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appena sotto il pomo d'Adamo, con il metro leggermente inclinato in avanti. Testa dritta, sguardo avanti, spalle rilassate.`)
};

/**
* | output |
* | --- |
* | "Just below the Adam's apple, the tape tilted slightly forward. Head level, looking ahead, shoulders loose." |
*
* @param {Body_Measures_How_NeckInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_how_neck = /** @type {((inputs?: Body_Measures_How_NeckInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_How_NeckInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_how_neck(inputs)
	if (locale === "es-419") return es_419_body_measures_how_neck(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_how_neck(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_how_neck(inputs)
	if (locale === "de-DE") return de_de2_body_measures_how_neck(inputs)
	if (locale === "it-IT") return it_it2_body_measures_how_neck(inputs)
	return en_us2_body_measures_how_neck(inputs)
});
export { body_measures_how_neck as "body-measures.how_neck" }